import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  tabs: {
    minHeight: 'unset',
    '& .MuiTabs-scroller': {
      '& .MuiTabs-flexContainer': {},
    },
  },
  tab: {
    minHeight: '100% !important',
    minWidth: 'fit-content',
    textTransform: 'none',
    fontSize: { xs: '14px', md: '16px' },
    fontWeight: 500,
    color: 'text.primary',
    opacity: 0.6,
    '&.Mui-selected': {
      color: 'primary.main',
      opacity: 1,
      backgroundColor: 'custom.primaryLight !important',
    },
    borderRight: '1px solid',
    borderColor: 'border.light',
  },
  buttonGroup: {
    '& .MuiButton-root': {
      whiteSpace: 'nowrap',
      minWidth: 'fit-content',
      '&[data-selected="true"]': {
        backgroundColor: 'custom.primaryLight',
        color: 'primary.main',
      },
      '@media (max-width: 599.95px)': {
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&:active': {
          backgroundColor: 'transparent',
        },
        '&[data-selected="true"]:hover': {
          backgroundColor: 'custom.primaryLight',
        },
        '&[data-selected="true"]:active': {
          backgroundColor: 'custom.primaryLight',
        },
      },
    },
    minWidth: '100%',
  },
  overflowBoxWrapper: {
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },
  wrapper: {
    position: 'sticky',
    top: '80px',
    zIndex: 10,
    backgroundColor: 'common.white',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
